const sendEmails = [
  {
    value: 0,
    label: 'No'
  },
  {
    value: 1,
    label: 'Yes'
  },
  {
    value: 2,
    label: 'Send only if account is charged'
  }
]
export default sendEmails



// WEBPACK FOOTER //
// ./src/constants/SendEmailOptions.ts